// survey-success-modal.component.ts
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'app-hormigon-survey-success-modal',
    templateUrl: './survey-success-modal.component.html',
    styleUrls: ['./survey-success-modal.component.css'],
    standalone: false
})
export class HormigonSurveySuccessModalComponent {

  
  constructor(
    private dialogRef: MatDialogRef<HormigonSurveySuccessModalComponent>,
    private router: Router
  ) {}

  close() {
    this.dialogRef.close();
    this.router.navigate(['/pedidospendiente']);
  }
}

